"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const use_query_params_1 = require("use-query-params");
const state_1 = require("@airstudio/state");
const react_router_dom_1 = require("react-router-dom");
const BasicComponent_1 = require("../BasicComponent");
const App = (props) => {
    const { isProcessing, errorMessage } = react_redux_1.useSelector(state_1.Selectors.Config.state);
    const { isAuthenticated } = react_redux_1.useSelector(state_1.Selectors.Session.state);
    if (isProcessing) {
        return props.loading
            ? React.createElement(props.loading, null)
            : React.createElement(BasicComponent_1.BasicComponent, null, "Loading config");
    }
    if (errorMessage) {
        return props.error
            ? React.createElement(props.error, { errorMessage: errorMessage })
            : React.createElement(BasicComponent_1.BasicComponent, null,
                "Error loading remote config: ",
                React.createElement("i", null, errorMessage));
    }
    if (!isAuthenticated) {
        return props.authentication
            ? React.createElement(props.authentication, null)
            : React.createElement(BasicComponent_1.BasicComponent, null, "Authentication needed");
    }
    return (React.createElement("div", null, props.children));
};
exports.AppWrapper = (props) => {
    return (React.createElement(react_redux_1.Provider, { store: state_1.store },
        React.createElement(react_router_dom_1.BrowserRouter, null,
            React.createElement(use_query_params_1.QueryParamProvider, { ReactRouterRoute: react_router_dom_1.Route },
                React.createElement(App, Object.assign({}, props))))));
};
//# sourceMappingURL=index.js.map